
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.75 6.99C20.61 6.44 20.06 6.12 19.51 6.24C17.13 6.77 14.48 7 12 7C9.51999 7 6.86999 6.77 4.48999 6.24C3.93999 6.12 3.38999 6.44 3.24999 6.99C3.10999 7.55 3.44999 8.12 3.99999 8.25C5.60999 8.61 7.34999 8.86 8.99999 9V21C8.99999 21.55 9.44999 22 9.99999 22C10.55 22 11 21.55 11 21V16H13V21C13 21.55 13.45 22 14 22C14.55 22 15 21.55 15 21V9C16.65 8.86 18.39 8.61 19.99 8.25C20.55 8.12 20.89 7.55 20.75 6.99ZM12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2C10.9 2 9.99999 2.9 9.99999 4C9.99999 5.1 10.9 6 12 6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-accessibility-new`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAccessibilityNew

    ```js
    <b-new-b-icon-accessibility-new />
    ```
</docs>


